import { render, staticRenderFns } from "./HostedInternalReviewForm.vue?vue&type=template&id=bede74ae&"
import script from "./HostedInternalReviewForm.vue?vue&type=script&lang=js&"
export * from "./HostedInternalReviewForm.vue?vue&type=script&lang=js&"
import style0 from "./HostedInternalReviewForm.vue?vue&type=style&index=0&id=bede74ae&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports